import { useCallback } from 'react';

import { useToasts } from 'dibs-toaster/exports/useToasts';

import {
    AddToFavoritesToastContent,
    RemoveFromFavoritesToastContent,
} from './FavoritesToastsContent';
import { SHARED_TOAST_PROPS } from './sharedToastProps';
import { isItemFavoritingVariant } from './abTests';
import { trackItemFavoritingToast } from './tracking';
import { ADD_TO_FAVORITES_ACTION } from './constants';

const useFavoritesToasts = (): {
    addToFavoritesToast: () => void;
    removeFromFavoritesToast: () => void;
} => {
    const { addToast } = useToasts();

    const addToFavoritesToast = useCallback(() => {
        if (!isItemFavoritingVariant()) {
            return;
        }

        addToast({
            toast: {
                ...SHARED_TOAST_PROPS,
                children: <AddToFavoritesToastContent />,
            },
            toastAction: ADD_TO_FAVORITES_ACTION,
        });
        trackItemFavoritingToast({ trigger: 'favorited' });
    }, [addToast]);

    const removeFromFavoritesToast = useCallback(() => {
        if (!isItemFavoritingVariant()) {
            return;
        }

        addToast({
            toast: {
                ...SHARED_TOAST_PROPS,
                children: <RemoveFromFavoritesToastContent />,
            },
        });
        trackItemFavoritingToast({ trigger: 'favorite removed' });
    }, [addToast]);

    return {
        addToFavoritesToast,
        removeFromFavoritesToast,
    };
};

export { useFavoritesToasts };
